import wxWorkAxios from '@/utils/wxWorkAxios'

/**
 * 获取登录图片
 * @returns
 */
 const getWxUrl = () => wxWorkAxios.get("/recruit/api/user/authorize", null, {
    requireAuth: false
  });
  
  /**
  * 获取UserId
  * @returns
  */
  const getUserId = (code) => wxWorkAxios.get("/recruit/api/user/code", {
    code
  },{
    requireAuth: false
  });

export default {
    getWxUrl,
    getUserId,
}